import React, { FC, ReactNode } from 'react';
import { Code } from '@cld/code-snippet';
import { CodeWrapper } from '@cld/widget-demos-common';

interface HalfHeightCodeWrapperProps {
  children: ReactNode;
  isExpanded: boolean;
}

export const HalfHeightCodeWrapper: FC<HalfHeightCodeWrapperProps> = ({ children, isExpanded }) => (
  <CodeWrapper size={isExpanded ? 'full' : 'half'} data-test="code-wrapper" >
    <Code syntax="javascript" showLineNumbers>
      {children}
    </Code>
  </CodeWrapper>
);
